import { useAppSelector } from "../../../hooks";
import RemoveHistoryDialog from "../dialogs/RemoveHistoryDialog";

const RemoveHistoryDialogSwitcher: React.FC<{}> = () => {
    const historyState = useAppSelector(state => state.history);
    return historyState.removeHistoryDialogVisible ? <RemoveHistoryDialog /> : null;
}

export default RemoveHistoryDialogSwitcher;